import { getCollectionNode, setCollectionNode } from 'shared-utils/src/myCasaCollections';

import { MY_COLLECTIONS_IDS, MY_COLLECTIONS_TYPES } from 'shared-constants/src/mycasa26/collection_configurations';

import { saveAddressCollection } from '@client/helpers/MyCasaHelpers';

import { RECENTADDRESSES_LS_LIMIT } from '../constants';

import normalizeAddressToApi from 'shared-utils/src/normalizeAddressToApi';

export default (newAddress, portal26Domain) => {
  const normalized = normalizeAddressToApi(newAddress);
  const recentArr = (getCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.RECENT)?.data || []).map(normalizeAddressToApi);
  const excludeDuplicates = recentArr.filter(addr =>
    addr.street !== normalized.street ||
    (addr.street === normalized.street && addr.town !== normalized.town)
  );
  const updatedRecent = [normalized, ...excludeDuplicates];

  if (updatedRecent.length > RECENTADDRESSES_LS_LIMIT) {
    updatedRecent.pop();
  }

  setCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.RECENT, { data: updatedRecent, count: updatedRecent.length });
  saveAddressCollection(portal26Domain, MY_COLLECTIONS_IDS.RECENT, normalized);

  return updatedRecent;
};
